import { render, staticRenderFns } from "./HealthyStep.vue?vue&type=template&id=3abf73d0&scoped=true"
import script from "./HealthyStep.vue?vue&type=script&lang=js"
export * from "./HealthyStep.vue?vue&type=script&lang=js"
import style0 from "./HealthyStep.vue?vue&type=style&index=0&id=3abf73d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abf73d0",
  null
  
)

export default component.exports